/* unplugin-vue-components disabled */import script from "./YQueryItem.vue?vue&type=script&setup=true&lang=tsx"
export * from "./YQueryItem.vue?vue&type=script&setup=true&lang=tsx"

const cssModules = {}
import style0 from "./YQueryItem.vue?vue&type=style&index=0&id=e905b8cc&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__